"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var validator_1 = require("validator");
var types_1 = require("../../types");
document.addEventListener('alpine:init', function () {
    var autocomplete, stripe, elements, cardNumber, cardExpiry, cardCvc;
    Alpine.data('donationForm', function (_a) {
        var publicKey = _a.publicKey;
        var steps = [
            { step: 1, title: 'Your gift' },
            { step: 2, title: 'Your details' },
            { step: 3, title: 'Payment details' },
        ];
        return {
            success: false,
            loading: false,
            ccLoading: false,
            submitted: false,
            currentStep: 1,
            manualAddressEntry: false,
            inputs: {
                frequency: 'one off',
                amountMethod: 'dollar-handles',
                amount: 0,
                support: '',
                firstName: '',
                lastName: '',
                email: '',
                addressAutocomplete: '',
                address: '',
                suburb: '',
                state: '',
                postcode: '',
                country: '',
                newsletter: false,
                token: '',
                pmToken: '',
                piToken: '',
                turnstileToken: '',
            },
            errors: {
                firstName: '',
                lastName: '',
                email: '',
                addressAutocomplete: '',
                address: '',
                suburb: '',
                state: '',
                postcode: '',
                country: '',
                card: '',
                // Errors set by default for CC fields..
                cardNumber: 'Please enter your credit card number',
                cardExpiry: 'Please set your credit card expiration date',
                cardCvc: 'Please enter your credit card CVC number',
                server: '',
            },
            init: function () {
                this.initAddressPlacesAutocomplete();
            },
            initStripe: function () {
                return __awaiter(this, void 0, void 0, function () {
                    var response, cardStyle;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.ccLoading = true;
                                stripe = Stripe(publicKey);
                                return [4 /*yield*/, this.$store.app.api('donations/stripe', {
                                        amount: this.inputs.amount,
                                    })];
                            case 1:
                                response = _a.sent();
                                // @ts-ignore
                                elements = stripe.elements({ clientSecret: response.data.clientSecret });
                                // Set payment intent token from api response
                                this.inputs.piToken = response.data.piToken;
                                cardStyle = {
                                    classes: {
                                        base: 'bg-white w-full px-3 py-4 transition rounded border border-kingfisher-100/20',
                                        focus: 'outline-none outline-peppermint',
                                        invalid: 'border-rose',
                                    },
                                };
                                cardNumber = elements.create('cardNumber', __assign({ disableLink: true, iconStyle: 'solid' }, cardStyle));
                                cardExpiry = elements.create('cardExpiry', __assign({}, cardStyle));
                                cardCvc = elements.create('cardCvc', __assign({}, cardStyle));
                                cardNumber.mount('#stripe-cc-number');
                                cardExpiry.mount('#stripe-cc-expiry');
                                cardCvc.mount('#stripe-cc-cvc');
                                cardNumber.on('change', function (e) {
                                    _this.errors.cardNumber = e.complete ? '' : 'Please enter your credit card number';
                                });
                                cardExpiry.on('change', function (e) {
                                    _this.errors.cardExpiry = e.complete ? '' : 'Please set your credit card expiration date';
                                });
                                cardCvc.on('change', function (e) {
                                    _this.errors.cardCvc = e.complete ? '' : 'Please enter your credit card CVC number';
                                });
                                this.ccLoading = false;
                                return [2 /*return*/];
                        }
                    });
                });
            },
            stepInfo: function (type) {
                var _this = this;
                var step = steps.find(function (s) { return s.step === _this.currentStep; });
                switch (type) {
                    case 'step':
                        return "Step ".concat(step.step);
                    case 'title':
                        return step.title;
                }
            },
            setAmount: function (amount, method, resetCustomAmount) {
                this.inputs.amount = amount;
                this.inputs.amountMethod = method;
                if (resetCustomAmount) {
                    this.$refs.customAmount.value = '';
                }
            },
            goToStep: function (step) {
                var _this = this;
                this.currentStep = step;
                // Reset the 'submitted' flag.
                this.submitted = false;
                setTimeout(function () {
                    _this.$store.app.scrollTo(_this.$root, 150);
                }, 100);
            },
            submitStep1: function () {
                var _this = this;
                this.submitted = true;
                if (this.inputs.frequency && this.inputs.amount >= 1) {
                    this.goToStep(2);
                    this.$nextTick(function () {
                        _this.$refs.firstName.focus();
                    });
                }
            },
            submitStep2: function () {
                var valid = true;
                var firstInvalidElement;
                this.submitted = true;
                // Reset errors.
                this.errors.firstName = '';
                this.errors.lastName = '';
                this.errors.email = '';
                // Validate first name.
                if (!(0, validator_1.isLength)(this.inputs.firstName, { min: 2 })) {
                    valid = false;
                    this.errors.firstName = 'Please enter your first name.';
                    if (!firstInvalidElement) {
                        firstInvalidElement = this.$refs.firstName;
                    }
                }
                // Validate last name.
                if (!(0, validator_1.isLength)(this.inputs.lastName, { min: 2 })) {
                    valid = false;
                    this.errors.lastName = 'Please enter your last name.';
                    if (!firstInvalidElement) {
                        firstInvalidElement = this.$refs.lastName;
                    }
                }
                // Validate email.
                if (!(0, validator_1.isEmail)(this.inputs.email)) {
                    valid = false;
                    this.errors.email = 'Please enter a valid email address.';
                    if (!firstInvalidElement) {
                        firstInvalidElement = this.$refs.email;
                    }
                }
                if (this.manualAddressEntry) {
                    // Reset errors.
                    this.errors.address = '';
                    this.errors.suburb = '';
                    this.errors.state = '';
                    this.errors.postcode = '';
                    this.errors.country = '';
                    // Validate address.
                    if (!(0, validator_1.isLength)(this.inputs.address, { min: 2 })) {
                        valid = false;
                        this.errors.address = 'Please enter your street address.';
                        if (!firstInvalidElement) {
                            firstInvalidElement = this.$refs.address;
                        }
                    }
                    // Validate suburb.
                    if (!(0, validator_1.isLength)(this.inputs.suburb, { min: 2 })) {
                        valid = false;
                        this.errors.suburb = 'Please enter your suburb.';
                        if (!firstInvalidElement) {
                            firstInvalidElement = this.$refs.suburb;
                        }
                    }
                    // Validate state.
                    if (!(0, validator_1.isLength)(this.inputs.state, { min: 2 })) {
                        valid = false;
                        this.errors.state = 'Please enter your state.';
                        if (!firstInvalidElement) {
                            firstInvalidElement = this.$refs.state;
                        }
                    }
                    // Validate postcode.
                    if (!(0, validator_1.isLength)(this.inputs.postcode, { min: 2 })) {
                        valid = false;
                        this.errors.postcode = 'Please enter your post code.';
                        if (!firstInvalidElement) {
                            firstInvalidElement = this.$refs.postcode;
                        }
                    }
                    // Validate country.
                    if (!(0, validator_1.isLength)(this.inputs.country, { min: 2 })) {
                        valid = false;
                        this.errors.country = 'Please enter your country.';
                        if (!firstInvalidElement) {
                            firstInvalidElement = this.$refs.country;
                        }
                    }
                }
                else {
                    valid = false;
                    this.errors.addressAutocomplete = 'Please search and select your address from the results list.';
                    if (!firstInvalidElement) {
                        firstInvalidElement = this.$refs.addressAutocomplete;
                    }
                }
                if (valid) {
                    this.initStripe();
                    this.goToStep(3);
                }
                else {
                    if (firstInvalidElement) {
                        firstInvalidElement.focus();
                    }
                }
            },
            submitStep3: function () {
                return __awaiter(this, void 0, void 0, function () {
                    var valid;
                    var _this = this;
                    return __generator(this, function (_a) {
                        valid = true;
                        this.submitted = true;
                        this.errors.server = '';
                        // Only continue if the CC fields are filled.
                        if (this.errors.cardNumber || this.errors.cardExpiry || this.errors.cardCvc) {
                            valid = false;
                        }
                        if (valid) {
                            this.loading = true;
                            this.$store.app.loadTurnstile('#turnstile-donate', 'donate', function (turnstileToken, callbackMethod) { return __awaiter(_this, void 0, void 0, function () {
                                var paymentMethodResponse, token, response;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            // console.group('Turnstile response')
                                            // console.log('TOKEN: ', turnstileToken || 'N/A');
                                            // console.log('CALLBACK METHOD:', callbackMethod);
                                            // console.groupEnd();
                                            if (callbackMethod === types_1.TurnstileMethods.BEFORE_INTERACTIVE) {
                                                this.loading = false;
                                                return [2 /*return*/, false];
                                            }
                                            if (!(turnstileToken && callbackMethod === types_1.TurnstileMethods.HAS_TOKEN)) return [3 /*break*/, 6];
                                            this.loading = true;
                                            // Add the token to the fields we're sending to the backend.
                                            this.inputs.turnstileToken = turnstileToken;
                                            return [4 /*yield*/, stripe.createPaymentMethod({
                                                    type: 'card',
                                                    card: cardNumber,
                                                })];
                                        case 1:
                                            paymentMethodResponse = _a.sent();
                                            this.inputs.pmToken = paymentMethodResponse.paymentMethod.id;
                                            return [4 /*yield*/, stripe.createToken(cardNumber)];
                                        case 2:
                                            token = (_a.sent()).token;
                                            if (!token) return [3 /*break*/, 4];
                                            this.inputs.token = token.id;
                                            return [4 /*yield*/, this.sendRequest()];
                                        case 3:
                                            response = _a.sent();
                                            if (response.success) {
                                                this.success = true;
                                                this.$store.app.scrollTo(this.$root, 150);
                                                this.track();
                                            }
                                            else {
                                                this.errors.server = response.message;
                                            }
                                            this.loading = false;
                                            return [3 /*break*/, 5];
                                        case 4:
                                            console.error('Stripe token was not generated');
                                            this.loading = false;
                                            _a.label = 5;
                                        case 5: return [3 /*break*/, 7];
                                        case 6:
                                            this.loading = false;
                                            console.error('No token returned');
                                            _a.label = 7;
                                        case 7: return [2 /*return*/];
                                    }
                                });
                            }); });
                        }
                        else {
                            // Need to show an error...
                            // console.log('step 3 not valid');
                        }
                        return [2 /*return*/];
                    });
                });
            },
            sendRequest: function () {
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.$store.app.api('donations/payment', this.inputs)];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                });
            },
            formatedAmount: function () {
                if (Number.isInteger(this.inputs.amount)) {
                    return '$' + this.inputs.amount;
                }
                return ('$' +
                    this.inputs.amount.toFixed(2).toLocaleString('en-AU', {
                        style: 'currency',
                        currency: 'AUD',
                    }));
            },
            submitText: function () {
                return this.loading ? 'Sending...' : 'Submit donation';
            },
            track: function () {
                this.$store.app.track({
                    event: 'form_submit',
                    form_variant: 'donation page',
                    form_name: 'donate',
                    donation_frequency: this.inputs.frequency,
                    donation_value: this.inputs.amount,
                    donation_handle: this.inputs.amountMethod,
                });
            },
            personalisedThankYou: function () {
                if (this.inputs.firstName) {
                    return "Thank you ".concat(this.inputs.firstName, "!");
                }
                return 'Thank you!';
            },
            initAddressPlacesAutocomplete: function () {
                return __awaiter(this, void 0, void 0, function () {
                    var Autocomplete, findComponent;
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.$store.app.loadGooglePlaces()];
                            case 1:
                                Autocomplete = (_a.sent()).Autocomplete;
                                // Don't submit the form when users press enter in the google address field
                                this.$refs.addressAutocomplete.addEventListener('keydown', function (event) {
                                    if (event.key === 'Enter') {
                                        event.preventDefault();
                                    }
                                });
                                autocomplete = new Autocomplete(this.$refs.addressAutocomplete, {
                                    componentRestrictions: {
                                        country: 'AU',
                                    },
                                    fields: ['address_components', 'geometry'],
                                });
                                findComponent = function (components, type, name) {
                                    if (name === void 0) { name = 'long_name'; }
                                    if (!(components === null || components === void 0 ? void 0 : components.length))
                                        return '';
                                    var component = components.find(function (c) { return c.types.includes(type); });
                                    return (component && component[name]) || '';
                                };
                                autocomplete.addListener('place_changed', function () {
                                    var place = autocomplete.getPlace();
                                });
                                // Make sure the places autocomplete field is registered with Alpine.
                                google.maps.event.addListener(autocomplete, 'place_changed', function () {
                                    var place = autocomplete.getPlace();
                                    if (!place)
                                        return;
                                    // Reset the address fields.
                                    _this.inputs.address = '';
                                    _this.inputs.suburb = '';
                                    _this.inputs.state = '';
                                    _this.inputs.postcode = '';
                                    _this.inputs.country = '';
                                    var subPremise = findComponent(place.address_components, 'subpremise', 'long_name');
                                    var streetNumber = findComponent(place.address_components, 'street_number', 'long_name');
                                    var streetName = findComponent(place.address_components, 'route', 'long_name');
                                    subPremise = subPremise ? "".concat(subPremise, "/") : '';
                                    _this.inputs.address = "".concat(subPremise).concat(streetNumber, " ").concat(streetName).trim();
                                    _this.inputs.suburb = findComponent(place.address_components, 'locality', 'long_name');
                                    _this.inputs.postcode = findComponent(place.address_components, 'postal_code', 'long_name');
                                    _this.inputs.state = findComponent(place.address_components, 'administrative_area_level_1', 'long_name');
                                    _this.inputs.country = findComponent(place.address_components, 'country', 'long_name');
                                    _this.$nextTick(function () {
                                        _this.manualAddressEntry = true;
                                    });
                                });
                                return [2 /*return*/];
                        }
                    });
                });
            },
        };
    });
});
